export const APP_API_URL = process.env.REACT_APP_API_URL;
export const APP_API_URL_V2 = process.env.REACT_APP_API_URL_V2;
